import Link from "next/link";
import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/utils";

// Cabecera de página ÚNICA para toda la plataforma: mismo título, mismo subtítulo y mismo hueco
// de acción a la derecha, igual en listas (Reservas, Informes…), ajustes y detalle. Las páginas
// que se abren DESDE la barra superior no llevan nada más (como Reservas). Solo las que se abren
// "entrando" desde una lista (detalle) pueden pasar `back` = un único enlace "‹ volver", no un
// breadcrumb que se llena ni un menú resumen.
export function PageHeader({
  title,
  subtitle,
  back,
  action,
  className,
}: {
  title?: string;
  subtitle?: string;
  back?: { href: string; label: string };
  action?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn("mb-6", className)}>
      {back && (
        <Link
          href={back.href}
          className="mb-2 inline-flex items-center gap-1 text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          <ChevronLeft className="size-4" />
          {back.label}
        </Link>
      )}
      {(title || action) && (
        <div className="flex flex-wrap items-start justify-between gap-3">
          {title ? (
            <div>
              <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
              {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
            </div>
          ) : (
            <div />
          )}
          {action && <div className="flex flex-wrap items-center gap-2">{action}</div>}
        </div>
      )}
    </div>
  );
}
